module.exports = __webpack_public_path__ + "static/media/Golf_Cart.ec377f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Golf_Cart.png
// module id = 3033
// module chunks = 0